import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import SplashScreen from './SplashScreen.js';
import RecipeList from './RecipeList.js';
import RecipeDetail from './RecipeDetail.js';
import UpdateNotification from './UpdateNotification.js';
import AdminDashboard from './AdminDashboard.js';
import analytics from './analytics.js';
import './App.css';
import './index.css';

function App() {
  const [isLoading, setIsLoading] = useState(true);
  const [contentLoaded, setContentLoaded] = useState(false);
  const [isOnline, setIsOnline] = useState(navigator.onLine);

  useEffect(() => {
    const hasLoadedBefore = localStorage.getItem('hasLoadedBefore');
    if (hasLoadedBefore) {
      setIsLoading(false);
    }

    // Set timeout to reset the flag after 10 seconds
    const timer = setTimeout(() => {
      localStorage.removeItem('hasLoadedBefore');
    }, 10000);

    // Add event listener to reset the flag when the app is closed
    const handleBeforeUnload = () => {
      localStorage.removeItem('hasLoadedBefore');
    };
    window.addEventListener('beforeunload', handleBeforeUnload);

    // Simulate content loading
    setTimeout(() => {
      setContentLoaded(true);
    }, 1000); // Simulating loading time

    // Cleanup the timer and event listener
    return () => {
      clearTimeout(timer);
      window.removeEventListener('beforeunload', handleBeforeUnload);
    };
  }, []);

  // Handle online/offline events
  useEffect(() => {
    const handleOnline = () => {
      setIsOnline(true);
      console.log('🌐 App is back online');
      analytics.trackEvent('network_status_change', { status: 'online' });
    };

    const handleOffline = () => {
      setIsOnline(false);
      console.log('📱 App is now offline');
      analytics.trackEvent('network_status_change', { status: 'offline' });
    };

    window.addEventListener('online', handleOnline);
    window.addEventListener('offline', handleOffline);

    return () => {
      window.removeEventListener('online', handleOnline);
      window.removeEventListener('offline', handleOffline);
    };
  }, []);

  if (isLoading) {
    return <SplashScreen setIsLoading={setIsLoading} />;
  }

  return (
    <Router>
      <UpdateNotification />
      {!isOnline && (
        <div className="offline-indicator">
          <div className="offline-content">
            📱 You're offline - showing cached content
          </div>
        </div>
      )}
      {contentLoaded ? (
        <Routes>
          <Route path="/" element={<RecipeList />} />
          <Route path="/recipes" element={<RecipeList />} />
          <Route path="/recipes/:id" element={<RecipeDetail />} />
          <Route path="/admin-seabird-2024-analytics" element={<AdminDashboard />} />
        </Routes>
      ) : (
        <div>Loading...</div>
      )}
    </Router>
  );
}

export default App;
